import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

interface DealInformationState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    document: any;

    meta: any;
}

const state: DealInformationState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    document: {},
    meta: {},
};

const initState: any = cloneDeep(state);

const DEAL_DATA = 'DEAL_DATA';

export function productDetails(docId: string) {
    const columns: any = {
      id: 'deal.id',
      products: 'dpc.products',
      client_products: 'cpc.products',
  
      counterparty_id: 'counterparty.id',
      counterparty_name: 'counterparty.name',
      counterparty_inn: 'counterparty.inn',
      counterparty_kpp: 'counterparty.kpp',
      counterparty_requesites: 'counterparty.requesites',
      counterparty_legal_address: 'counterparty.legal_address',
  
      warehouse_name: 'warehouse.name',
      destination_warehouse_name: 'destination_warehouse.name',
      zone_name: 'zone.name',
      zone_group_name: 'zone_group.name',
  
      payment_type: 'payment_type.name',
      expected_payment_date: {$add: ['deal.expected_delivery_date', 'pdp.period']},
      preferred_product_1: 'p_1.name',
      preferred_product_container_1: 'pc_1.name',
      preferred_product_2: 'p_2.name',
      preferred_product_container_2: 'pc_2.name',
      preferred_product_3: 'p_3.name',
      preferred_product_container_3: 'pc_3.name',
      operators: 'people.operators'
    };
  
    return {
        columns,
        from: 's:deals',
        from_as: 'deal',
        joins: [
            {
              join: 's:clients',
              type: 'left',
              as:   'client',
              on: {
                $eq: ['client.id', 'deal.client_id']
              }
            },
            {
              join: 's:payment_deferment_periods',
              type: 'left',
              as:   'pdp',
              on:   {$eq: ['pdp.id', 'client.payment_deferment_period_id']}
            },

            {
              join: 's:product_containers',
              type: 'left',
              as:   'pc_1',
              on: {
                  $eq: ['client.preferred_product_container_id', 'pc_1.id']
              }
            },
            {
              join: 's:products',
              type: 'left',
              as:   'p_1',
              on: {
                  $eq: ['pc_1.product_id', 'p_1.id']
              }
            },
            {
              join: 's:product_containers',
              type: 'left',
              as:   'pc_2',
              on: {
                  $eq: ['client.preferred_product_container_2_id', 'pc_2.id']
              }
            },
            {
              join: 's:products',
              type: 'left',
              as:   'p_2',
              on: {
                  $eq: ['pc_2.product_id', 'p_2.id']
              }
            },
            {
              join: 's:product_containers',
              type: 'left',
              as:   'pc_3',
              on: {
                  $eq: ['client.preferred_product_container_3_id', 'pc_3.id']
              }
            },
            {
              join: 's:products',
              type: 'left',
              as:   'p_3',
              on: {
                  $eq: ['pc_3.product_id', 'p_3.id']
              }
            },

            {
              join: 's:delivery_points',
              type: 'left',
              as:   'point',
              on: {
                $eq: ['deal.delivery_point_id', 'point.id']
              }
            },
          {
            join: 's:counterparties',
            type: 'left',
            as:   'counterparty',
            on: {
              $eq: ['deal.counterparty_id', 'counterparty.id']
            }
          },
  
          {
            join: 's:delivery_points_delivery_zones',
            type: 'left',
            as:   'dpdz',
            on: {
              $eq: ['dpdz.delivery_point_id', 'point.id']
            }
          },
          {
            join: 's:delivery_zones',
            type: 'left',
            as:   'zone',
            on: {
              $eq: ['zone.id', 'dpdz.delivery_zone_id']
            }
          },
          {
            join: 's:delivery_zone_groups',
            type: 'left',
            as:   'zone_group',
            on: {
              $eq: ['zone.delivery_zone_group_id', 'zone_group.id']
            }
          },
          {
            join: 's:payment_types',
            type: 'left',
            as:   'payment_type',
            on: {
              $eq: ['deal.payment_type_id', 'payment_type.id']
            }
          },
  
          {
            join: 's:warehouses',
            type: 'left',
            as:   'warehouse',
            on: {
              $eq: ['deal.delivery_warehouse_id', 'warehouse.id']
            }
          },
  
          {
            join: 's:warehouses',
            type: 'left',
            as:   'destination_warehouse',
            on: {
              $eq: ['deal.destination_warehouse_id', 'destination_warehouse.id']
            }
          },
          {
            join: {
              columns: {
                client_id: 'people.client_id',
                operators: {
                  $array_agg: {
                      $obj: {
                          name: 'people.name',
                          primary_phone: 'people.primary_phone',
                          primary_email: 'people.primary_email',
                          contacts: 'people.contacts',
                      }
                  }
                }
              },
              from: 's:people',
              from_as: 'people',
              where: {$eq: ['people.role', {$:'decision_operator'}]},
              groups: [
                'people.client_id'
              ]
            },
            type: 'left',
            as:   'people',
            on: {
              $eq: ['people.client_id', 'client.id'],
            }
          },
          {
            join: {
              columns: {
                deal_id: 'dpc.deal_id',
                count: { $count: 'dpc.id' },
                products: {
                  $array_agg: {
                      $obj: {
                          price: 'dpc.container_price',
                          price_per_kg: 'pc.price_per_kg',
                          product: 'p.name',
                          quantity: 'dpc.container_quantity',
                          container: 'pc.name',
                          weight: 'pc.weight'
                      }
                  }
              }
              },
              from: 's:deal_product_containers',
              from_as: 'dpc',
              joins: [
                {
                  join: 's:product_containers',
                  type: 'left',
                  as:   'pc',
                  on: {
                      $eq: ['dpc.product_container_id', 'pc.id']
                  }
                },
                {
                  join: 's:products',
                  type: 'left',
                  as:   'p',
                  on: {
                      $eq: ['pc.product_id', 'p.id']
                  }
                },
              ],
              groups: [
                'dpc.deal_id'
              ]
            },
            type: 'left',
            as: 'dpc',
            on: { $eq: ['dpc.deal_id', 'deal.id'] }
          },
          {
            join: {
              columns: {
                client_id: 'cpc.client_id',
                products: {
                  $array_agg: {
                      $obj: {
                          price: 'cpc.container_price',
                          product: 'p.name',
                          container: 'pc.name',
                          weight: 'pc.weight'
                      }
                  }
              }
              },
              from: 's:client_product_containers',
              from_as: 'cpc',
              joins: [
                {
                  join: 's:product_containers',
                  type: 'left',
                  as:   'pc',
                  on: {
                      $eq: ['cpc.product_container_id', 'pc.id']
                  }
                },
                {
                  join: 's:products',
                  type: 'left',
                  as:   'p',
                  on: {
                      $eq: ['pc.product_id', 'p.id']
                  }
                },
              ],
              groups: [
                'cpc.client_id'
              ],
              where: { $eq: ['cpc.hidden', {$: false}] },
            },
            type: 'left',
            as: 'cpc',
            on: { $eq: ['cpc.client_id', 'client.id'] }
          },
        ],
        where: {
          $eq: [`deal.id`, {$: docId}]
        }
    }
  }

export const actions: ActionTree<DealInformationState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q(DEAL_DATA)
                .raw('documents.list')
                .action(productDetails(documentId)),
          ]).then((result: ServerResult) => {

            commit('SET_DEAL_DATA', result.getOperation(DEAL_DATA).getContent());
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },

};

export const mutations: MutationTree<DealInformationState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },
  SET_DEAL_DATA(state, data) {
      const schema = data.schema;
      const document = data.documents[0];
      state.meta = fetchEnumsFromSchema(schema);

      document.operators.map((item: any) => {
        
        item.primary_phone = item.contacts.find((contact: any) => contact.is_primary && contact.type == 'phone');
        item.primary_email = item.contacts.find((contact: any) => contact.is_primary && contact.type == 'email');
        return item
      })

      state.document = document
  },
};

export const getters: GetterTree<DealInformationState, RootState> = {
  
};

export const STORE_KEY = '$_deal_information';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
